<template>
  <div class="content">
    <section class="page-content container-fluid">
      <div class="row">
        <!-- Configs -->
        <div class="col-12 col-sm position-relative">
          <!-- <PageHeader :breadcrumbLinks="breadcrumbLinks" title="Omni Business" :subtitle="$t('widget.my-widgets')" :subtitle3rd="$t('widget.widget-title')" /> -->
          <PageHeader :breadcrumbLinks="breadcrumbLinks" title="Chat" :subtitle="$t('widget.my-widgets')" :subtitle3rd="$t('widget.widget-title')" />
          <!-- Language -->
          <!-- <div class="container c-container">
            <div class="row language-row">
              <div class="col-12 col-sm-6">
                <p>{{$t('app.language')}}</p>
                <p>Selecione o idioma do bate-papo:</p>
              </div>
              <div class="col-12 col-sm-4 lang-column mb-4">
                <div class="lang-wrapper">
                  <b-dropdown
                    id="dropdown-2"
                    class="lang-menu"
                    :text="$t('options-div.select-lang')"
                    variant="transparent form-control"
                    v-model="selectedLang"
                  >
                    <b-dropdown-item
                      v-for="(lang, i) in languages"
                      :key="i"
                      :value="languages[i]"
                    >
                      {{lang}}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div> -->
          <!--/Language -->
          <!-- ChatIcon2 -->
          <div class="container c-container chat-icon">
            <div class="row">
              <div class="col-12">
                <p>{{ $t('widget.choose') }}</p>
              </div>
              <div class="col-12 icon-images">
                <button class="widget-icon-wrapper" :class="chatIcon === 0 ? 'active' : ''" @click="chooseIcon(0)">
                  <Icon1 :color="configs.mainColor" />
                </button>
                <button class="widget-icon-wrapper" :class="chatIcon === 1 ? 'active' : ''" @click="chooseIcon(1)">
                  <Icon2 :color="configs.mainColor" />
                </button>
                <button class="widget-icon-wrapper" :class="chatIcon === 2 ? 'active' : ''" @click="chooseIcon(2)">
                  <Icon3 :color="configs.mainColor" />
                </button>
                <button class="widget-icon-wrapper" :class="chatIcon === 3 ? 'active' : ''" @click="chooseIcon(3)">
                  <Icon4 :color="configs.mainColor" />
                </button>
                <!-- <img class="img-fluid" src="@/assets/widget/widget-1.png" alt="">
                <img class="img-fluid" src="@/assets/widget/widget-2.png" alt="">
                <img class="img-fluid" src="@/assets/widget/widget-3.gif" alt="">
                <img class="img-fluid" src="@/assets/widget/widget-4.gif" alt=""> -->
              </div>
            </div>
          </div>
          <!--/ChatIcon2 -->
          <!-- Color pick -->
          <div class="container c-container">
            <div class="row color-row">
              <div class="col-12 col-sm-6">
                <p>{{ $t('widget.highlight') }}</p>
                <p>{{ $t('widget.highlight-desc') }}:</p>
              </div>
              <fieldset class="col-12 col-sm-4 color-column mb-4 d-flex justify-content-end">
                <ul class="list-unstyled">
                  <li>
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" checked @click="configs.mainColor = '#752de6'" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" @click="configs.mainColor = '#e67e2d'" />
                        <div class="control_indicator orange"></div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" @click="configs.mainColor = '#e0e62d'" />
                        <div class="control_indicator yellow"></div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" @click="configs.mainColor = '#2d4ce6'" />
                        <div class="control_indicator blue"></div>
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" @click="configs.mainColor = '#9ca7b0'" />
                        <div class="control_indicator gray"></div>
                      </label>
                    </div>
                  </li>
                  <li class="color-picker-nav" style="position: relative">
                    <div class="control-group opt-3">
                      <label class="control control-checkbox">
                        <input type="radio" name="colors_scheme" />
                        <div
                          :class="{
                            lighter: isLighter(configs.mainColor, 127.5),
                            default: configs.mainColor === '#FFFFFF',
                          }"
                          class="control_indicator color-selector"
                          :style="{ backgroundColor: configs.mainColor }"
                          @click="chooseColor = !chooseColor"
                        ></div>
                      </label>
                    </div>
                    <div class="color-menu">
                      <div class="container">
                        <div class="row">
                          <div class="col-12">
                            <div class="card mb-0">
                              <div class="card-body">
                                <div class="container-fluid">
                                  <div class="row">
                                    <div class="col-6">
                                      <h5 id="main-color">
                                        <span class="material-symbols-outlined">
                                          format_color_fill
                                        </span>
                                        Widget
                                      </h5>
                                      <div class="row colors-sample-wrapper">
                                        <template v-for="(color, i) in sampleSchemeColors">
                                          <div :key="i" class="color-btn-wrapper">
                                            <div class="control-group opt-3">
                                              <label class="control control-checkbox">
                                                <input type="radio" name="colors_scheme" @click="configs.mainColor = color" />
                                                <div
                                                  class="control_indicator"
                                                  :style="{
                                                    backgroundColor: color,
                                                    borderColor: color,
                                                  }"
                                                ></div>
                                              </label>
                                            </div>
                                            <span class="sr-only">{{ color }}</span>
                                            <!--  <button class="btn-sample-color" :style="{
                                              backgroundColor: color
                                            }" @click="configs.mainColor = color">
                                              <span class="sr-only">{{color}}</span>
                                            </button> -->
                                          </div>
                                        </template>
                                        <input
                                          class="form-control"
                                          maxlength="7"
                                          placeholder="#0E1421"
                                          type="text"
                                          v-model="color"
                                          v-on:keyup="(event) => (configs.mainColor = color)"
                                        />
                                      </div>
                                      <!-- <ul class="list-unstyled">
                                        <li>
                                          <div class="control-group opt-3">
                                            <label
                                              class="control control-checkbox"
                                            >
                                              <input
                                                type="radio"
                                                name="colors_scheme"
                                                @click="
                                                  configs.mainColor = '#e67e2d'
                                                "
                                              />
                                              <div
                                                class="control_indicator orange"
                                              ></div>
                                            </label>
                                          </div>
                                        </li>
                                      </ul> -->
                                    </div>
                                    <div class="col-6">
                                      <h5 id="push-color">
                                        <span class="material-symbols-outlined">
                                          format_color_fill
                                        </span>
                                        Push
                                      </h5>
                                      <div class="row colors-sample-wrapper">
                                        <template v-for="(color, i) in samplePushColors">
                                          <div :key="i" class="color-btn-wrapper">
                                            <div class="control-group opt-3">
                                              <label class="control control-checkbox">
                                                <input type="radio" name="colors_scheme_push" @click="configs.pushColor = color" />
                                                <div
                                                  class="control_indicator"
                                                  :style="{
                                                    backgroundColor: color,
                                                    borderColor: color,
                                                  }"
                                                ></div>
                                              </label>
                                            </div>
                                            <span class="sr-only">{{ color }}</span>
                                            <!-- <button class="btn-sample-color" :style="{
                                              backgroundColor: color
                                            }" @click="configs.pushColor = color">
                                              <span class="sr-only">{{color}}</span>
                                            </button> -->
                                          </div>
                                        </template>
                                        <input
                                          class="form-control"
                                          type="text"
                                          v-model="colorPush"
                                          maxlength="7"
                                          placeholder="#00CC00"
                                          v-on:keyup="(event) => (configs.pushColor = colorPush)"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="color_picker-wrapper">
                                  <color-picker :value="configs.mainColor" :disableAlpha="true" @input="updateColor" />
                                </div>
                                <div class="color_picker-push-wrapper">
                                  <color-picker :value="configs.pushColor" :disableAlpha="true" @input="updatePushColor" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- <li class="profile-picture">Simulate
                    <img src="@/assets/avatar.svg" alt="" />
                  </li> -->
                </ul>
              </fieldset>
            </div>
          </div>
          <!--/Color pick -->
          <!-- Username -->
          <div class="container c-container">
            <div class="row username-row">
              <div class="col-12 col-sm-6">
                <p>{{ $t('widget.widget-title') }}</p>
                <p>{{ $t('widget.username-desc') }}</p>
              </div>
              <div class="col-12 col-sm-4 username-column mb-4">
                <div class="username-wrapper">
                  <input :placeholder="$t('app.username')" type="text" class="form-control username-input" v-model="configs.title" />
                </div>
              </div>
            </div>
          </div>
          <!--/Username -->
          <!-- Intro message -->
          <div class="container c-container">
            <div class="row message-row">
              <div class="col-12 col-sm-6">
                <p>{{ $t('widget.intro-msg') }}</p>
                <p>
                  {{ $t('widget.changes') }}<br /><router-link class="text-yup" to="/settings"
                    ><u>{{ $t('widget.system-adjustments') }}<span class="material-symbols-outlined ml-1" style="top: 6px; position: relative">arrow_outward</span></u></router-link
                  >
                </p>
              </div>
              <div class="col-12 col-sm-4 message-column mb-4">
                <div class="message-wrapper">
                  <textarea class="form-control" v-model="configs.intro"></textarea>
                </div>
              </div>
            </div>
          </div>
          <!--/Intro message -->
          <!-- Position -->
          <div class="container c-container">
            <div class="row position-row">
              <div class="col-12">
                <p>{{ $t('widget.position') }}</p>
                <p>{{ $t('widget.position-desc') }}</p>
              </div>
              <div class="col-12 position-wrapper mb-4">
                <picture :class="{ active: configs.align === 'left' }">
                  <img role="button" @click="configs.align = 'left'" class="img-fluid" src="@/assets/widget/widget-novo-l.png" alt="" />
                  <span>{{ $t('widget.align.left') }}</span>
                </picture>
                <picture :class="{ active: configs.align === 'center' }">
                  <img role="button" @click="configs.align = 'center'" class="img-fluid" src="@/assets/widget/widget-novo-c.png" alt="" />
                  <span>{{ $t('widget.align.center') }}</span>
                </picture>
                <picture :class="{ active: configs.align === 'right' }">
                  <img role="button" @click="configs.align = 'right'" class="img-fluid" src="@/assets/widget/widget-novo-r.png" alt="" />
                  <span>{{ $t('widget.align.right') }}</span>
                </picture>
              </div>
              <div class="col-10 d-flex">
                <button class="btn btn-outline-primary">{{ $t('app.cancel') }}</button>
                <button class="btn btn-primary ml-auto">
                  {{ $t('generic-str.save') }}
                </button>
              </div>
            </div>
          </div>
          <!--/Position -->
          <!-- ChatIcon -->
          <!-- <div class="icon-wrapper"> -->
          <!-- <img class="chat-icon" :src="require(`@/assets/icons/chat-${this.chatIcon}.svg`)" alt="" srcset=""> -->
          <!-- <template v-if="chatIcon === 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="72.425" height="61.704" viewBox="0 0 72.425 61.704">
                <g transform="translate(-190.675 -707.6)">
                  <path d="M64.04,1.35H7.61a6.492,6.492,0,0,0-6.6,8.33l7.62,32.6a10.561,10.561,0,0,0,10.48,7.83l30.1-1.75c2.66-.15,5.74-.33,8.4-.49l9.17,12.37s1.35-17.89,1.92-23.85c.64-6.64,2.94-26.53,2.94-26.53a7.508,7.508,0,0,0-7.61-8.5Z" transform="translate(190.652 707)" fill="#fff" :stroke="configs.mainColor" stroke-width="1.5"/>
                  <g :fill="configs.mainColor">
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)"/>
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)"/>
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)"/>
                  </g>
                </g>
              </svg>
            </template>
            <template v-else-if="chatIcon === 1">
              <svg xmlns="http://www.w3.org/2000/svg" width="68.095" height="75.154" viewBox="0 0 68.095 75.154">
                <g transform="translate(0.75 0.75)">
                  <path d="M51.854,65.5a21.293,21.293,0,0,1-1.32-3.7,33.213,33.213,0,1,0-9.925,4,21.072,21.072,0,0,0,17.881,7.8,20.935,20.935,0,0,1-6.632-8.095Z" fill="#fff" :stroke="configs.mainColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                  <g :fill="configs.mainColor">
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(17.915 30.937)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(30.17 30.937)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(42.128 30.937)" />
                  </g>
                </g>
              </svg>
            </template>
            <template v-else-if="chatIcon === 2">
              <svg xmlns="http://www.w3.org/2000/svg" width="84.747" height="73.625" viewBox="0 0 84.747 73.625">
                <g transform="translate(-160.476 -532.655)">
                  <path d="M97.54,16.04,29.23,34.25a11.085,11.085,0,0,0-7.42,13.82l4.92,16.2A14.107,14.107,0,0,0,41.01,73.8l2.43-.24,9.24,15.66,3.17-16.89,31.78-3.17c6.08-.61,12.12-5.99,13.42-11.96l4.77-33.48c1.3-5.97-2.43-9.42-8.28-7.67Z" transform="translate(139.145 517.061)" :fill="configs.mainColor"/>
                  <path d="M11503.258,10668.051s-8.391-23.589-5.442-28.214,58.294-17.58,58.294-17.58-49.341,16.114-53.7,19.229S11503.258,10668.051,11503.258,10668.051Z" transform="translate(-11331.443 -10083.234)" fill="rgba(255,255,255,.4)"/>
                  <path d="M41.01,73.8l2.43-.24,9.24,15.66,3.17-16.89,31.78-3.17c6.08-.61,12.12-5.99,13.42-11.96,0,0,5.755-36.682,4.653-33.429S87.637,60.654,41.01,73.8Z" transform="translate(139.145 517.061)" fill="rgba(0,0,0,.25)"/>
                  <g fill="#fff" transform="translate(-24.044 -167.533)">
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)" />
                  </g>
                </g>
              </svg>
            </template>
            <template v-else-if="chatIcon === 3">
              <svg xmlns="http://www.w3.org/2000/svg" width="68.598" height="59.515" viewBox="0 0 68.598 59.515">
                <g transform="translate(-177.399 -629.234)">
                  <path d="M60.81,10.05C50.71,2.66,38.59.35,26.22,1.73,14.77,3.18,4.8,10.31,1.62,21.44-.93,31.5,2.58,42.71,11.1,48.69c12.12,8.24,27.59,6.01,39.84-1.19a46.391,46.391,0,0,1,2.47,11.85c3.71-6.41,6.04-12.62,6.52-18.57.38-.36.75-.72,1.12-1.08a29.131,29.131,0,0,0,4.84-6.73,18.619,18.619,0,0,0-5.08-22.9Z" transform="translate(177.373 628.648)" fill="#fff" :stroke="configs.mainColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                  <g :fill="configs.mainColor" transform="translate(-15.192 -76.707)">
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)" />
                    <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)" />
                  </g>
                </g>
              </svg>
            </template> -->
          <!-- <button class="btn" @click="changeIcon()">
              <span class="material-symbols-outlined">sync</span>
            </button>
          </div> -->
          <!--/ChatIcon -->
        </div>
        <!--/Configs -->
        <div class="col-12 col-sm-4 col-widget">
          <!-- <div class="sim-wrapper">
            <div class="center-both">
              <img class="img-fluid" src="@/assets/widget/widget-sim.webp" alt="">
              <a
                :href="`/live/simulator#${$live.accountId}`"
                class="text-yup live-simulate-client pl-2"
                target="_yup-chat-simulator"
                :disabled="!$live.ready || !$live.accountId"
              >
                <span class="hide-mobile">{{$t('widget.sim')}}</span>
                <span class="material-symbols-outlined ml-2">arrow_outward</span>
              </a>
            </div>
          </div> -->
          <!-- <img class="img-fluid w-100" src="@/assets/widget/widget-sim.webp" alt=""> -->
          <div class="preview-wrapper" :class="`widget-` + configs.align">
            <img class="img-fluid w-100" src="@/assets/widget/website-preview.png" alt="" />
            <!-- Widget (Preview) -->
            <svg class="widget-preview" width="141" height="185" viewBox="0 0 141 185" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_319_9229)">
                <rect x="4.67285" y="2" width="132" height="177" rx="4" fill="white" />
              </g>
              <!-- Sent icon -->
              <path
                d="M108.869 163.848C108.692 163.919 108.523 163.904 108.364 163.804C108.205 163.704 108.125 163.559 108.125 163.37V160.236C108.125 160.106 108.163 159.994 108.24 159.899C108.317 159.805 108.414 159.746 108.532 159.722L113.473 158.5L108.532 157.243C108.414 157.219 108.317 157.16 108.24 157.066C108.163 156.971 108.125 156.859 108.125 156.729V153.63C108.125 153.442 108.205 153.297 108.364 153.197C108.523 153.096 108.692 153.082 108.869 153.152L120.415 158.004C120.627 158.099 120.733 158.264 120.733 158.5C120.733 158.736 120.627 158.902 120.415 158.996L108.869 163.848Z"
                :fill="configs.mainColor"
              />
              <!-- Top background -->
              <path d="M5 6C5 3.79086 6.79086 2 9 2H132.3C134.509 2 136.3 3.79086 136.3 6V33.7817H5V6Z" :fill="configs.mainColor" />
              <path
                d="M15.1445 15.9127V18.6093C15.1445 18.879 15.2108 19.0866 15.3435 19.2321C15.4762 19.3777 15.6709 19.4504 15.9278 19.4504C16.1846 19.4504 16.3815 19.3777 16.5184 19.2321C16.6554 19.0866 16.7239 18.879 16.7239 18.6093V15.9127H17.8218V18.6029C17.8218 19.0053 17.7362 19.3456 17.565 19.6238C17.3938 19.902 17.1626 20.1117 16.8716 20.253C16.5848 20.3942 16.2638 20.4649 15.9085 20.4649C15.5532 20.4649 15.2343 20.3964 14.9518 20.2594C14.6736 20.1182 14.4532 19.9084 14.2905 19.6302C14.1279 19.3477 14.0465 19.0053 14.0465 18.6029V15.9127H15.1445ZM20.0502 20.4713C19.7378 20.4713 19.4596 20.4178 19.2156 20.3108C18.9716 20.2038 18.779 20.0582 18.6377 19.8742C18.4965 19.6858 18.4173 19.4761 18.4002 19.245H19.4852C19.4981 19.3691 19.5559 19.4697 19.6586 19.5467C19.7613 19.6238 19.8876 19.6623 20.0374 19.6623C20.1744 19.6623 20.2792 19.6366 20.352 19.5853C20.4291 19.5296 20.4676 19.459 20.4676 19.3734C20.4676 19.2706 20.4141 19.1957 20.3071 19.1487C20.2001 19.0973 20.0267 19.0416 19.787 18.9817C19.5302 18.9218 19.3162 18.8597 19.145 18.7955C18.9737 18.727 18.8261 18.6222 18.7019 18.4809C18.5778 18.3354 18.5157 18.1406 18.5157 17.8966C18.5157 17.6912 18.5714 17.505 18.6827 17.3381C18.7982 17.1668 18.9652 17.032 19.1835 16.9336C19.4061 16.8351 19.6693 16.7859 19.9732 16.7859C20.4226 16.7859 20.7758 16.8972 21.0326 17.1198C21.2937 17.3423 21.4435 17.6377 21.482 18.0058H20.4676C20.4505 17.8817 20.3948 17.7832 20.3006 17.7105C20.2108 17.6377 20.0909 17.6013 19.9411 17.6013C19.8127 17.6013 19.7142 17.627 19.6458 17.6783C19.5773 17.7254 19.543 17.7918 19.543 17.8774C19.543 17.9801 19.5965 18.0572 19.7035 18.1085C19.8148 18.1599 19.986 18.2113 20.2172 18.2626C20.4826 18.3311 20.6987 18.3996 20.8657 18.4681C21.0326 18.5323 21.1781 18.6393 21.3023 18.7891C21.4307 18.9346 21.497 19.1315 21.5013 19.3798C21.5013 19.5895 21.4414 19.7779 21.3215 19.9448C21.2059 20.1075 21.0369 20.2359 20.8143 20.33C20.596 20.4242 20.3413 20.4713 20.0502 20.4713ZM25.5502 18.5708C25.5502 18.6735 25.5438 18.7805 25.5309 18.8918H23.0462C23.0633 19.1144 23.1339 19.2856 23.2581 19.4055C23.3865 19.521 23.5427 19.5788 23.7268 19.5788C24.0007 19.5788 24.1912 19.4633 24.2982 19.2321H25.4667C25.4068 19.4675 25.2977 19.6794 25.1393 19.8678C24.9852 20.0561 24.7904 20.2038 24.555 20.3108C24.3196 20.4178 24.0564 20.4713 23.7653 20.4713C23.4143 20.4713 23.1018 20.3964 22.8279 20.2466C22.5539 20.0968 22.3399 19.8827 22.1858 19.6045C22.0317 19.3263 21.9547 19.001 21.9547 18.6286C21.9547 18.2562 22.0296 17.9309 22.1794 17.6527C22.3335 17.3744 22.5475 17.1604 22.8215 17.0106C23.0954 16.8608 23.41 16.7859 23.7653 16.7859C24.112 16.7859 24.4202 16.8587 24.6898 17.0042C24.9595 17.1497 25.1692 17.3573 25.3191 17.627C25.4732 17.8966 25.5502 18.2113 25.5502 18.5708ZM24.4266 18.2819C24.4266 18.0935 24.3624 17.9437 24.234 17.8324C24.1056 17.7212 23.9451 17.6655 23.7524 17.6655C23.5684 17.6655 23.4122 17.719 23.2837 17.826C23.1596 17.933 23.0826 18.085 23.0526 18.2819H24.4266ZM27.2273 17.4344C27.3557 17.2375 27.5162 17.0834 27.7089 16.9721C27.9015 16.8565 28.1155 16.7987 28.3509 16.7987V17.9609H28.0491C27.7752 17.9609 27.5697 18.0208 27.4328 18.1406C27.2958 18.2562 27.2273 18.4617 27.2273 18.757V20.4199H26.1294V16.8373H27.2273V17.4344ZM33.0041 20.6832V21.7361H29.0234V20.6832H33.0041ZM36.0685 16.7987C36.4879 16.7987 36.8218 16.9357 37.0701 17.2096C37.3226 17.4793 37.4489 17.8517 37.4489 18.3268V20.4199H36.3574V18.4745C36.3574 18.2348 36.2953 18.0486 36.1712 17.9159C36.0471 17.7832 35.8801 17.7169 35.6704 17.7169C35.4606 17.7169 35.2937 17.7832 35.1696 17.9159C35.0454 18.0486 34.9834 18.2348 34.9834 18.4745V20.4199H33.8855V16.8373H34.9834V17.3124C35.0947 17.154 35.2445 17.0299 35.4328 16.94C35.6212 16.8458 35.833 16.7987 36.0685 16.7987ZM37.9935 18.6222C37.9935 18.2541 38.062 17.9309 38.199 17.6527C38.3402 17.3744 38.5307 17.1604 38.7704 17.0106C39.0101 16.8608 39.2776 16.7859 39.573 16.7859C39.8255 16.7859 40.046 16.8373 40.2343 16.94C40.4269 17.0427 40.5746 17.1775 40.6773 17.3445V16.8373H41.7752V20.4199H40.6773V19.9127C40.5703 20.0796 40.4205 20.2145 40.2279 20.3172C40.0395 20.4199 39.8191 20.4713 39.5666 20.4713C39.2755 20.4713 39.0101 20.3964 38.7704 20.2466C38.5307 20.0925 38.3402 19.8763 38.199 19.5981C38.062 19.3156 37.9935 18.9903 37.9935 18.6222ZM40.6773 18.6286C40.6773 18.3546 40.6003 18.1385 40.4462 17.9801C40.2964 17.8217 40.1123 17.7426 39.894 17.7426C39.6757 17.7426 39.4895 17.8217 39.3354 17.9801C39.1856 18.1342 39.1107 18.3482 39.1107 18.6222C39.1107 18.8961 39.1856 19.1144 39.3354 19.2771C39.4895 19.4354 39.6757 19.5146 39.894 19.5146C40.1123 19.5146 40.2964 19.4354 40.4462 19.2771C40.6003 19.1187 40.6773 18.9025 40.6773 18.6286ZM47.1409 16.7987C47.5861 16.7987 47.9392 16.9336 48.2003 17.2032C48.4657 17.4729 48.5984 17.8474 48.5984 18.3268V20.4199H47.5069V18.4745C47.5069 18.2434 47.4448 18.0657 47.3207 17.9416C47.2009 17.8132 47.0339 17.749 46.8199 17.749C46.6059 17.749 46.4368 17.8132 46.3127 17.9416C46.1928 18.0657 46.1329 18.2434 46.1329 18.4745V20.4199H45.0414V18.4745C45.0414 18.2434 44.9794 18.0657 44.8552 17.9416C44.7354 17.8132 44.5684 17.749 44.3544 17.749C44.1404 17.749 43.9713 17.8132 43.8472 17.9416C43.7273 18.0657 43.6674 18.2434 43.6674 18.4745V20.4199H42.5695V16.8373H43.6674V17.2867C43.7787 17.1369 43.9242 17.0192 44.104 16.9336C44.2838 16.8437 44.4871 16.7987 44.714 16.7987C44.9836 16.7987 45.2233 16.8565 45.4331 16.9721C45.6471 17.0877 45.814 17.2525 45.9339 17.4665C46.058 17.2696 46.2271 17.1091 46.4411 16.9849C46.6551 16.8608 46.8884 16.7987 47.1409 16.7987ZM52.7435 18.5708C52.7435 18.6735 52.737 18.7805 52.7242 18.8918H50.2395C50.2566 19.1144 50.3272 19.2856 50.4513 19.4055C50.5797 19.521 50.736 19.5788 50.92 19.5788C51.194 19.5788 51.3845 19.4633 51.4915 19.2321H52.66C52.6001 19.4675 52.4909 19.6794 52.3326 19.8678C52.1785 20.0561 51.9837 20.2038 51.7483 20.3108C51.5129 20.4178 51.2496 20.4713 50.9586 20.4713C50.6076 20.4713 50.2951 20.3964 50.0212 20.2466C49.7472 20.0968 49.5332 19.8827 49.3791 19.6045C49.225 19.3263 49.148 19.001 49.148 18.6286C49.148 18.2562 49.2229 17.9309 49.3727 17.6527C49.5268 17.3744 49.7408 17.1604 50.0147 17.0106C50.2887 16.8608 50.6033 16.7859 50.9586 16.7859C51.3053 16.7859 51.6135 16.8587 51.8831 17.0042C52.1528 17.1497 52.3625 17.3573 52.5123 17.627C52.6664 17.8966 52.7435 18.2113 52.7435 18.5708ZM51.6199 18.2819C51.6199 18.0935 51.5557 17.9437 51.4273 17.8324C51.2988 17.7212 51.1383 17.6655 50.9457 17.6655C50.7617 17.6655 50.6054 17.719 50.477 17.826C50.3529 17.933 50.2758 18.085 50.2459 18.2819H51.6199Z"
                fill="white"
              />
              <path
                d="M126.661 13.8243L126.213 13.3762L128.677 10.9121L126.213 8.44802L126.661 8L129.126 10.4641L131.59 8L132.038 8.44802L129.574 10.9121L132.038 13.3762L131.59 13.8243L129.126 11.3602L126.661 13.8243Z"
                fill="white"
              />
              <path
                d="M13.6729 51.9262C13.6729 50.8624 14.5352 50 15.599 50H101.747C102.81 50 103.673 50.8624 103.673 51.9262V58.0738C103.673 59.1376 102.81 60 101.747 60H15.599C14.5352 60 13.6729 59.1376 13.6729 58.0738V51.9262Z"
                fill="#F2F2F2"
              />
              <path
                d="M13.6729 65.9262C13.6729 64.8624 14.5352 64 15.599 64H88.7467C89.8105 64 90.6729 64.8624 90.6729 65.9262V72.0738C90.6729 73.1376 89.8105 74 88.7467 74H15.599C14.5352 74 13.6729 73.1376 13.6729 72.0738V65.9262Z"
                fill="#F2F2F2"
              />
              <!-- Background sent msg -->
              <path
                d="M63.1062 96.9262C63.1062 95.8624 63.9686 95 65.0324 95H130.201C131.265 95 132.127 95.8624 132.127 96.9262V103.074C132.127 104.138 131.265 105 130.201 105H65.0324C63.9686 105 63.1062 104.138 63.1062 103.074V96.9262Z"
                :fill="hexToRGBA(configs.mainColor, 0.3)"
              />
              <line x1="13.5073" y1="143.839" x2="126.188" y2="143.839" stroke="#E5E5E5" stroke-width="0.321027" />
              <defs>
                <filter id="filter0_d_319_9229" x="0.672852" y="0" width="140" height="185" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="2" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0.458824 0 0 0 0 0.176471 0 0 0 0 0.901961 0 0 0 0.08 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_319_9229" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_319_9229" result="shape" />
                </filter>
              </defs>
            </svg>
            <!--/Widget (Preview) -->
            <!-- Widget Icon (Preview) -->
            <Icon1 v-if="chatIcon === 0" class="widget-icon-preview" :width="64" :height="64" :color="configs.mainColor" />
            <Icon2 v-if="chatIcon === 1" class="widget-icon-preview" :width="64" :height="64" :color="configs.mainColor" />
            <Icon3 v-if="chatIcon === 2" class="widget-icon-preview" :width="64" :height="64" :color="configs.mainColor" />
            <Icon4 v-if="chatIcon === 3" class="widget-icon-preview" :width="64" :height="64" :color="configs.mainColor" />
            <!--/Widget Icon (Preview) -->
          </div>
          <a :href="`/live/simulator#${$live.accountId}`" class="text-yup live-simulate-client" target="_yup-chat-simulator" :disabled="!$live.ready || !$live.accountId">
            <span class="hide-mobile">{{ $t('widget.sim') }}</span>
            <span class="material-symbols-outlined ml-2">arrow_outward</span>
          </a>
          <div class="embed-code">
            <p>Embed Code</p>
            <p>{{ $t('webchat-component.copy-code') }}</p>
          </div>
          <div class="code-wrapper">
            <pre class="script-content" readonly ref="code" v-if="domain">
&lt;script src="{{ domain }}/yupchat.js"&gt;&lt;/script&gt;
&lt;script&gt;
var widget = YupChat();
widget.config({
  align: '{{ configs.align }}',
  color: '{{ configs.mainColor }}',
  pushColor: '{{ configs.pushColor }}',
  icon: '{{ configsIcon }}',
  title: '{{ configs.title }}'{{ configs.intro ? ',' : ''
              }}{{
                configs.intro
                  ? `
  intro: '${configs.intro.replace(/'/g, "''").replace(/\n/g, '\\n')}'`
                  : ''
              }}
});
widget.open('{{ account.id }}');
&lt;/script&gt;</pre
            >
            <button class="btn btn-yup-purple copy-code" @click="copyData">
              <span class="material-symbols-outlined mr-1">content_copy</span>
              <span class="hide-mobile">{{ $t('widget.copy') }}</span>
            </button>
          </div>
        </div>
        <div class="w-100"></div>
        <!-- Widget Column -->
        <div class="col-lg widget-column d-none">
          <div
            class="widget position-relative widget-sample"
            :class="{
              open: visible,
              center: configs.align === 'center',
              left: configs.align === 'left',
              right: configs.align === 'right',
            }"
          >
            <header :class="{ lighter: isLighter(configs.mainColor, 127.5) }" :style="{ backgroundColor: configs.mainColor }">
              <button @click="toggleVisibility">
                <i class="widget-min" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
              </button>
              <button class="widget-r" @click="toggleVisibility">
                <i class="widget-close" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
              </button>
              <h1>{{ configs.title }}</h1>
            </header>
            <section>
              <div class="widget-msg">
                <div>
                  <span>{{ configs.intro }}</span>
                  <div class="widget-status">
                    <time datetime="2022-03-12T22:22:11.898">Agora</time>
                    <span class="widget-msg-status">&#x1F5F8;&#x1F5F8;</span>
                  </div>
                </div>
                <footer>
                  <span>Agente</span>
                </footer>
              </div>
              <div class="widget-msg me" :class="{ lighter: isLighter(configs.mainColor, 127.5) }" :style="{ color: configs.mainColor }">
                <div :style="{ backgroundColor: hexToRGBA(configs.mainColor, 0.3) }">
                  <span>João Almeida</span>
                  <div class="widget-status">
                    <time datetime="2022-03-12T22:22:11.898">Agora</time>
                    <span class="widget-msg-status">&#x1F5F8;&#x1F5F8;</span>
                  </div>
                </div>
                <footer>
                  <span>Cliente</span>
                </footer>
              </div>
            </section>
            <footer>
              <input type="text" v-model="message" />
              <div class="widget-placeholder" v-if="!message">
                <span>Digite sua mensagem...</span>
              </div>
              <div class="widget-extras">
                <Emojis setClass="no" icon="mood" left="-4px" bottom="40px" />
                <button class="widget-btn" disabled>
                  <i class="widget-attach"></i>
                </button>
              </div>
              <button class="widget-btn">
                <i class="widget-send" :style="{ color: configs.mainColor }">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" :style="{ fill: configs.mainColor }">
                    <path
                      d="M958 461.2L73.8 18.4C31.2-3 3.2 18 11.5 65l55.2 309.6c6 33.9 31.6 64.8 63.2 80.9h328c24.6 0 44.5 20 44.5 44.6s-19.9 44.6-44.5 44.6h-333c-29.2 17-52.4 46.4-58.1 78.5L11.5 935c-8.3 47 19.7 67.9 62.3 46.6L958 538.8c42.7-21.3 42.7-56.2 0-77.6z"
                    />
                  </svg>
                </i>
              </button>
            </footer>
          </div>
        </div>
        <!--/Widget Column -->
        <!-- Copy and paste column -->
        <div class="col-lg alignement-column"></div>
        <!--/Copy and paste column -->
      </div>
    </section>
    <!-- Floating Widget -->
    <div
      class="widget"
      :class="{
        open: !visible,
        center: configs.align === 'center',
        left: configs.align === 'left',
        right: configs.align === 'right',
      }"
    >
      <header :class="{ lighter: isLighter(configs.mainColor, 127.5) }" :style="{ backgroundColor: configs.mainColor }">
        <button @click="toggleVisibility">
          <i class="widget-min" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
        </button>
        <button class="widget-r" @click="toggleVisibility">
          <i class="widget-close" :class="{ lighter: isLighter(configs.mainColor, 127.5) }"></i>
        </button>
        <h1>{{ configs.title }}</h1>
      </header>
      <section>
        <div class="widget-msg">
          <div>
            <span>{{ configs.intro }}</span>
            <div class="widget-status">
              <time datetime="2022-03-12T22:22:11.898">Agora</time>
              <span class="widget-msg-status">&#x1F5F8;&#x1F5F8;</span>
            </div>
          </div>
          <footer>
            <span>Agente</span>
          </footer>
        </div>
        <div class="widget-msg me" :class="{ lighter: isLighter(configs.mainColor, 127.5) }" :style="{ color: configs.mainColor }">
          <div :style="{ backgroundColor: hexToRGBA(configs.mainColor, 0.3) }">
            <span>João Almeida</span>
            <div class="widget-status">
              <time datetime="2022-03-12T22:22:11.898">Agora</time>
              <span class="widget-msg-status">&#x1F5F8;&#x1F5F8;</span>
            </div>
          </div>
          <footer>
            <span>Cliente</span>
          </footer>
        </div>
      </section>
      <footer>
        <input type="text" v-model="message" />
        <div class="widget-placeholder" v-if="!message">
          <span>Digite sua mensagem...</span>
        </div>
        <div class="widget-extras">
          <Emojis setClass="no" icon="emoji_emotions" left="-4px" bottom="40px" />
          <button class="widget-btn" disabled>
            <i class="widget-attach"></i>
          </button>
        </div>
        <button class="widget-btn">
          <i class="widget-send" :style="{ color: configs.mainColor }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" :style="{ fill: configs.mainColor }">
              <path
                d="M958 461.2L73.8 18.4C31.2-3 3.2 18 11.5 65l55.2 309.6c6 33.9 31.6 64.8 63.2 80.9h328c24.6 0 44.5 20 44.5 44.6s-19.9 44.6-44.5 44.6h-333c-29.2 17-52.4 46.4-58.1 78.5L11.5 935c-8.3 47 19.7 67.9 62.3 46.6L958 538.8c42.7-21.3 42.7-56.2 0-77.6z"
              />
            </svg>
          </i>
        </button>
      </footer>
    </div>
    <!--/Floating Widget -->
    <template v-if="null">
      <button
        class="widget-launch"
        @click="toggleVisibility"
        :class="{
          center: configs.align === 'center',
          left: configs.align === 'left',
          right: configs.align === 'right',
        }"
      >
        <span
          class="widget-push"
          :style="{
            backgroundColor: configs.pushColor,
            color: isLighter(configs.pushColor, 201) ? '#000' : '#fff',
          }"
          >1</span
        >
        <!-- <i class="widget-logo"></i> -->
        <div class="widget-logo-custom">
          <template v-if="chatIcon === 0">
            <svg xmlns="http://www.w3.org/2000/svg" width="72.425" height="61.704" viewBox="0 0 72.425 61.704">
              <g transform="translate(-190.675 -707.6)">
                <path
                  d="M64.04,1.35H7.61a6.492,6.492,0,0,0-6.6,8.33l7.62,32.6a10.561,10.561,0,0,0,10.48,7.83l30.1-1.75c2.66-.15,5.74-.33,8.4-.49l9.17,12.37s1.35-17.89,1.92-23.85c.64-6.64,2.94-26.53,2.94-26.53a7.508,7.508,0,0,0-7.61-8.5Z"
                  transform="translate(190.652 707)"
                  fill="#fff"
                  :stroke="configs.mainColor"
                  stroke-width="1.5"
                />
                <g :fill="configs.mainColor">
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)" />
                </g>
              </g>
            </svg>
          </template>
          <template v-else-if="chatIcon === 1">
            <svg xmlns="http://www.w3.org/2000/svg" width="68.095" height="75.154" viewBox="0 0 68.095 75.154">
              <g transform="translate(0.75 0.75)">
                <path
                  d="M51.854,65.5a21.293,21.293,0,0,1-1.32-3.7,33.213,33.213,0,1,0-9.925,4,21.072,21.072,0,0,0,17.881,7.8,20.935,20.935,0,0,1-6.632-8.095Z"
                  fill="#fff"
                  :stroke="configs.mainColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <g :fill="configs.mainColor">
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(17.915 30.937)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(30.17 30.937)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(42.128 30.937)" />
                </g>
              </g>
            </svg>
          </template>
          <template v-else-if="chatIcon === 2">
            <svg xmlns="http://www.w3.org/2000/svg" width="84.747" height="73.625" viewBox="0 0 84.747 73.625">
              <g transform="translate(-160.476 -532.655)">
                <path
                  d="M97.54,16.04,29.23,34.25a11.085,11.085,0,0,0-7.42,13.82l4.92,16.2A14.107,14.107,0,0,0,41.01,73.8l2.43-.24,9.24,15.66,3.17-16.89,31.78-3.17c6.08-.61,12.12-5.99,13.42-11.96l4.77-33.48c1.3-5.97-2.43-9.42-8.28-7.67Z"
                  transform="translate(139.145 517.061)"
                  :fill="configs.mainColor"
                />
                <path
                  d="M11503.258,10668.051s-8.391-23.589-5.442-28.214,58.294-17.58,58.294-17.58-49.341,16.114-53.7,19.229S11503.258,10668.051,11503.258,10668.051Z"
                  transform="translate(-11331.443 -10083.234)"
                  fill="rgba(255,255,255,.4)"
                />
                <path
                  d="M41.01,73.8l2.43-.24,9.24,15.66,3.17-16.89,31.78-3.17c6.08-.61,12.12-5.99,13.42-11.96,0,0,5.755-36.682,4.653-33.429S87.637,60.654,41.01,73.8Z"
                  transform="translate(139.145 517.061)"
                  fill="rgba(0,0,0,.25)"
                />
                <g fill="#fff" transform="translate(-24.044 -167.533)">
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)" />
                </g>
              </g>
            </svg>
          </template>
          <template v-else-if="chatIcon === 3">
            <svg xmlns="http://www.w3.org/2000/svg" width="68.598" height="59.515" viewBox="0 0 68.598 59.515">
              <g transform="translate(-177.399 -629.234)">
                <path
                  d="M60.81,10.05C50.71,2.66,38.59.35,26.22,1.73,14.77,3.18,4.8,10.31,1.62,21.44-.93,31.5,2.58,42.71,11.1,48.69c12.12,8.24,27.59,6.01,39.84-1.19a46.391,46.391,0,0,1,2.47,11.85c3.71-6.41,6.04-12.62,6.52-18.57.38-.36.75-.72,1.12-1.08a29.131,29.131,0,0,0,4.84-6.73,18.619,18.619,0,0,0-5.08-22.9Z"
                  transform="translate(177.373 628.648)"
                  fill="#fff"
                  :stroke="configs.mainColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
                <g :fill="configs.mainColor" transform="translate(-15.192 -76.707)">
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(211.66 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(223.916 729.452)" />
                  <circle cx="3.127" cy="3.127" r="3.127" transform="translate(235.873 729.452)" />
                </g>
              </g>
            </svg>
          </template>
        </div>
      </button>
    </template>
  </div>
</template>

<script>
import Emojis from '@/components/Emojis.vue';
import PageHeader from '@/components/rebranding/PageHeader.vue';
import Icon1 from '@/components/widget/Icon1.vue';
import Icon2 from '@/components/widget/Icon2.vue';
import Icon3 from '@/components/widget/Icon3.vue';
import Icon4 from '@/components/widget/Icon4.vue';
import $ from 'jquery';

export default {
  name: 'Widget',
  components: {
    // InfiniteLoading,
    Emojis,
    PageHeader,
    Icon1,
    Icon2,
    Icon3,
    Icon4,
  },
  data() {
    return {
      breadcrumbLinks: {
        1: '/live/reports/stat',
        2: '/live/configs/widget',
        3: '/live/configs/widget/config',
      },
      chooseColor: false,
      visible: true,
      message: '',
      color: '',
      colorPush: '',
      chatIcon: 0,
      colors: {
        hex: '#0E1421',
      },
      languages: ['pt-br', 'en', 'es'],
      selectedLang: 'pt-br',
      configs: {
        align: 'right',
        mainColor: '#752DE6',
        pushColor: '#00cc00',
        title: this.account?.name ?? 'Yup Chat',
        intro: 'Olá tudo bem? Para poder ajudar, qual seu nome completo?',
      },
      sampleSchemeColors: [
        '#B2DFDB',
        '#4DB6AC',
        '#009688',
        '#4CAF50',
        '#D4E157',
        '#9E9D24',
        '#FFF176',
        '#FDD835',
        '#F9AB25',
        '#F57F17',
        '#E53935',
        '#B71C1C',
        '#2196F3',
        '#0D47A1',
        '#9575CD',
        '#752DE6',
        '#F48FB1',
        '#F06292',
        '#9CA7B0',
        '#5D4037',
        '#3E2723',
        '#201918',
      ],
      samplePushColors: [
        '#B2DFDB',
        '#4DB6AC',
        '#009688',
        '#4CAF50',
        '#D4E157',
        '#9E9D24',
        '#FFF176',
        '#FDD835',
        '#F9AB25',
        '#F57F17',
        '#E53935',
        '#B71C1C',
        '#2196F3',
        '#0D47A1',
        '#9575CD',
        '#752DE6',
        '#F48FB1',
        '#F06292',
        '#9CA7B0',
        '#5D4037',
        '#3E2723',
        '#201918',
      ],
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    domain() {
      const domain = process.env?.VUE_APP_CHAT_WIDGET;

      if (domain) return domain.replace(/\/+$/, '');

      return domain;
    },
    configsIcon() {
      return this.chatIcon > -1 && this.chatIcon < 4 ? `ICON${this.chatIcon + 1}` : 'null';
    },
  },
  mounted() {
    const dropDown = $('.color-selector');

    /* $('.color-selector').click((e) => {
      dropDown.fadeToggle('fast');
      e.preventDefault();
    }); */

    /* $('div:not(.color-picker-nav, .color-selector)').click((e) => {
      dropDown.fadeOut('fast');
      e.preventDefault();
    }); */

    $(dropDown).click((e) => {
      $('.color-menu').fadeToggle('fast');
      e.preventDefault();
    });

    $('#main-color').click((e) => {
      $('.color_picker-push-wrapper').fadeOut('fast');
      $('.color_picker-wrapper').fadeToggle('fast');
      e.preventDefault();
    });

    $('#push-color').click((e) => {
      $('.color_picker-wrapper').fadeOut('fast');
      $('.color_picker-push-wrapper').fadeToggle('fast');
      e.preventDefault();
    });

    $(document).on('click', (e) => {
      const $target = $(e.target);
      if (!$target.is('.color-picker-nav') && !$target.is('.color-selector') && !$target.is('.color-menu *')) {
        $('.color-menu').fadeOut('fast');
      }
    });
  },
  destroyed() {},
  methods: {
    isLighter(input, maxHsp) {
      /* eslint no-bitwise: ["error", { "allow": [">>", "&"] }] */
      // If hex --> Convert it to RGB: http://gist.github.com/983661
      if (input.indexOf('#') === 0) input = input.slice(1);

      if (input.length < 5) input = input.replace(/./g, '$&$&');

      const color = +`0x${input}`;

      const r = color >> 16;
      const g = (color >> 8) & 255;
      const b = color & 255;

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b)) > maxHsp;
    },
    toggleVisibility() {
      this.visible = !this.visible;
    },
    updateMainColor(color) {
      this.configs.mainColor = color.hex;
    },
    updatePushColor(color) {
      this.configs.pushColor = color.hex;
    },
    async copyData() {
      this.$toast.show({
        title: 'Widget',
        content: 'Código copiado',
        type: 'success',
      });

      this.$clipboard(this.$refs.code.textContent);
    },
    updateColor(color) {
      this.configs.mainColor = color.hex;
    },
    /* Convert HEX to RGBA */
    hexToRGBA(hex, opacity) {
      let h = hex.replace('#', '');
      let i = 0;
      h = h.match(new RegExp(`(.{${h.length / 3}})`, 'g'));

      for (i; i < h.length; i += 1) h[i] = parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);

      if (typeof opacity !== 'undefined') h.push(opacity);

      return `rgba(${h.join(',')})`;
    },
    /* Change icon */
    changeIcon() {
      this.chatIcon += 1;
      if (this.chatIcon === 4) {
        this.chatIcon = 0;
      }
    },
    chooseIcon(e) {
      this.chatIcon = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  padding-bottom: 2rem;
}

.script-content {
  height: auto;
}

textarea.form-control {
  min-height: 200px;
}

.widget-config-colors::v-deep {
  .vc-sketch-presets > div:last-child {
    display: none;
  }
}

.widget-config-aligns {
  border: thin solid #dcdcdc;
  border-radius: 4px;

  p {
    margin: 0;
    min-height: 80px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: thin solid #efefef;
  }

  button {
    background: transparent;
    border: thin solid #dcdcdc;
    outline: none;
    border-radius: 6px;
    width: 100%;
    min-height: 10px;
    transition: all ease 0.2s;

    &:hover,
    &.active {
      background: #dcdcdc;
    }
  }
}

.widget-config-colors {
  padding: 1em 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.widget {
  border-radius: 0.3em;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  font-size: 10pt;
  background: var(--background-2);
  position: fixed;
  bottom: 5px;
  // right: 5px;
  z-index: 1151;
  overflow: hidden;
  height: 0;
  width: 0;

  &.left {
    left: 5px;
  }

  &.right {
    right: 5px;
  }

  &.center {
    transform: translateX(-50%);
    left: 50%;
  }

  &,
  * {
    transition: all 0.2s;
  }

  input[type='text'],
  textarea,
  button {
    border-radius: 0;
    -webkit-appearance: none;
    line-height: 1;
  }

  &.open {
    box-shadow: 0 5px 25px 9px rgba(0, 0, 0, 0.25);
    height: 480px;
    width: 320px;
  }

  & > header {
    position: relative;
    z-index: 101;
    text-align: center;
    height: 62px;
    box-shadow: 0 2px 6px -3px rgba(0, 0, 0, 0.5);
    color: #fff;

    button {
      background: transparent;
      border: none;
      height: 100%;
      width: 54px;
      float: left;

      &.widget-r {
        float: right;
      }

      i {
        display: inline-block;
        background: center center no-repeat;
        height: 16px;
        width: 16px;
      }
    }

    h1 {
      padding: 0 65px;
      padding: 0;
      margin: 0;
      height: 62px;
      font-size: 9pt;
      font-weight: bold;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 500;
      overflow: hidden;
      color: inherit;

      &::before {
        vertical-align: middle;
        display: inline-block;
        content: '';
        height: 100%;
        width: 0;
      }
    }
  }

  button {
    cursor: pointer;
    outline: none;
  }

  & > section,
  & > footer {
    border: 0 solid #ccc;
  }

  & > section {
    border-width: 0 thin 0 thin;
    height: calc(100% - 62px - 44px);
    overflow: auto;
    overflow-x: hidden;
  }

  & > footer {
    background: #fff;
    border-radius: 0 0 0.3em 0.3em;
    border-width: thin;
    position: relative;
    height: 44px;

    input[type='text'] {
      border: none;
      background: #fff;
      width: calc(100% - 46px);
      padding: 12px 2px 12px 74px;
      height: 100%;
      resize: none;
      position: relative;
      z-index: 100;
      overflow: auto;
      overflow-x: hidden;
      overflow-wrap: normal;
      white-space: pre;
      line-height: normal;
    }

    & > .widget-btn {
      position: absolute;
      right: 6px;
      top: 6px;
    }
  }

  button > i,
  .emojis::v-deep .popup-box-container button i {
    background: center center no-repeat;
    display: block;
    height: 64%;
    width: 64%;
    margin: 0 auto;
  }
}

.widget-msg {
  clear: both;
  position: relative;
  padding: 14px 28px;
  max-width: 70%;
  max-width: 90%;
  min-width: 75%;
  float: left;

  & > div {
    position: relative;
    padding: 12px;
    padding-bottom: 20px;
    background: #f2f2f2;
    border-radius: 5px 5px 5px 5px;

    & > span {
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }

  .widget-status {
    padding: 2px 10px;
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;

    time {
      margin-top: 10px;
      text-align: right;
      font-size: 75%;
    }
  }

  &.me {
    float: right;

    & > div {
      background: currentColor;
      border-radius: 5px 5px 5px 5px;

      & > span {
        color: #fff !important;
      }
    }

    .widget-status {
      color: #fff;
    }
  }

  & > footer {
    color: #070707;
    padding: 6px 2px;
    font-size: 78%;

    span {
      float: right;
    }
  }

  /* &::before {
    display: block;
    content: ' ';
    height: 0;
    position: absolute;
    pointer-events: none;
    border: solid transparent;
    border-top-color: #fff;
    border-right-color: #fff;
    border-width: 7px;
    left: 16px;
    top: 14px;
  }

  &.me::before {
    border-color: transparent;
    border-top-color: currentColor;
    border-left-color: currentColor;
    left: auto;
    right: 17px;
  } */
}

.widget-msg-status {
  margin-left: 4px;
  letter-spacing: -5px;
  font-weight: bolder;
}

.widget-btn,
.emojis::v-deep .popup-box-container button {
  font-size: 20pt;
  padding: 0;
  background: transparent;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 0.2em;
  cursor: pointer;
  vertical-align: middle;
}

.widget-placeholder {
  pointer-events: none;
  color: #cfcfcf;
  position: absolute;
  z-index: 101;
  top: 12px;
  left: 80px;
}

.widget-extras {
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 101;
  height: 100%;
  border-radius: 5px;
  padding: 5px 0 0 5px;
}

.widget-send svg {
  display: block;
  fill: currentColor;
}

.widget-emoji,
.emojis::v-deep .widget-emoji {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22 fill=%22%236c6c6c%22%3E%3Cpath d=%22M379.2 457.5c33.3 0 60.3-27 60.3-60.3s-27-60.4-60.3-60.4-60.3 27-60.3 60.4c0 33.3 27 60.3 60.3 60.3zM500 10C229.4 10 10 229.4 10 500s219.4 490 490 490 490-219.4 490-490S770.6 10 500 10zm0 914.6C265.4 924.6 75.3 734.5 75.3 500S265.4 75.3 500 75.3c234.5 0 424.6 190.1 424.6 424.6.1 234.6-190.1 424.7-424.6 424.7zm120.4-467.1c33.4 0 60.3-27 60.3-60.3s-26.9-60.4-60.3-60.4c-33.3 0-60.3 27-60.3 60.4 0 33.3 27.1 60.3 60.3 60.3zm100.5 90c-16.2 0-30.3 9.6-36.5 23.6-47.3 47.4-112.4 77-184.6 77s-137.3-29.6-184.6-77c-6.3-14-20.2-23.6-36.5-23.6-22.2 0-40.2 18-40.2 40.3 0 13 6.2 24.4 15.8 31.8l-2.1 2.1c62.2 65.8 150 107 247.6 107 102.7 0 194.6-45.7 257.2-117.5l-2.1-2c3.9-6.2 6.2-13.4 6.2-21.2.1-22.4-17.9-40.5-40.2-40.5z%22/%3E%3C/svg%3E') !important;
}
.widget-attach {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns%3D%22http://www.w3.org/2000/svg%22 viewBox%3D%220 0 1000 1000%22 fill%3D%22%236c6c6c%22%3E%3Cpath d%3D%22M841.5 390.5c-15.4-11.1-36.8-7.6-47.9 7.7L463.5 856.1c-.1-.1-.3-.2-.5-.3-.9 1.4-1.7 2.9-2.7 4.2-47.6 66.1-140.1 81.1-206.1 33.3S173.3 752.9 221 686.8c0-.1.1-.1.1-.2-.1-.1-.2-.1-.3-.2l409.1-567.3c31.6-43.8 92.9-53.7 136.6-22.1 43.7 31.7 53.6 93.1 22 136.9-.8 1-258 357-295.6 408.8l.1.1c-1.8 2.7-4.2 5.7-5.6 7.7-14.4 20-42.4 24.5-62.4 10.1s-24.5-42.5-10.1-62.5c.8-1.1 2.9-4.7 4.5-7.1l216.2-299.9c11.1-15.4 7.6-36.8-7.8-48-15.3-11.1-36.8-7.6-47.9 7.7l-219 304.4c-1 1.4-1.7 2.9-2.5 4.4h.1c-35.4 50.7-23.9 120.5 26.4 156.9 50.7 36.7 121.5 25.2 158.1-25.6 1.4-2 2.6-4.1 3.8-6.2.1.2.2.3.2.4l301.6-417.9c47.8-73.9 30-173.5-42.1-225.6-73.8-53.4-176.9-37.2-231 35.9 0 0-.1 0-.1-.1L163.3 649.1c0 .1-3.7 5.2-3.8 5.2.2.1.7-.1 1-.1-63.7 96.4-40.8 226.6 53.5 294.9 92.7 67 220.3 49.7 292.4-37 .1.4.1 1.1.3 1.4.1-.1 7.4-10.3 7.5-10.4l334.9-464.5c11.2-15.5 7.7-36.9-7.6-48.1z%22/%3E%3C/svg%3E') !important;
}
.widget-attach-upload {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg version=%221.1%22 xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 40 40%22%3E%3Cg fill=%22%23000%22%3E%3Cpath opacity=%220.2%22 d=%22M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z%22/%3E%3Cpath d=%22M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z%22%3E%3CanimateTransform attributeType=%22xml%22 attributeName=%22transform%22 type=%22rotate%22 from=%220 20 20%22 to=%22360 20 20%22 dur=%220.5s%22 repeatCount=%22indefinite%22/%3E%3C/path%3E%3C/g%3E%3C/svg%3E') !important;
}
.widget-min {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M 10,510 500,1000 990,510 892,412 500,804 108,412 Z%22 fill=%22%23fff%22/%3E%3C/svg%3E') !important;
}
.widget-close {
  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M990,108.7L598.7,500L990,891.3L891.3,990L500,598.7L108.7,990L10,891.3L401.3,500L10,108.7L108.7,10L500,401.3L891.3,10L990,108.7z%22 fill=%22%23fff%22/%3E%3C/svg%3E') !important;
}

.widget-launch {
  outline: none;
  cursor: pointer;
  border: none;
  // border-radius: 4rem;
  // background: #0e1421;
  background: transparent;
  // height: 4rem;
  // width: 4rem;
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.11), 0 2px 3px rgba(0, 0, 0, 0.18);
  pointer-events: auto;
  position: fixed;
  bottom: 11px;
  z-index: 1150;
  -webkit-appearance: none;
  transition: all ease 0.2s;

  &.left {
    left: 5px;
  }

  &.right {
    right: 5px;
  }

  &.center {
    transform: translateX(-50%);
    left: 50%;
  }

  .widget-logo-custom svg {
    display: block;
    height: 62px;
    width: 62px;
    margin: 0 auto;
  }

  i {
    display: block;
    height: 64%;
    width: 64%;
    margin: 0 auto;
    background: center center no-repeat;
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 height=%2238%22 width=%2232%22 viewBox=%220 0 130 150%22 fill=%22%23fff%22%3E%3Cpath d=%22m 48.108411,131.10047 c -2,0.45 -9.67,-6.3 -16.19,-11 -8.55,-6.3 -18,-12.6 -18.22,-17.54 V 43.830463 a 9.35,9.35 0 0 0 -2.92,0.27 c 0,0 -9.4500003,0.63 -9.4500003,14.57 0.22,11.7 0.22,55.330007 0.22,55.330007 0,0 -0.22,13.49 7.2,15.1 10.1200003,2 9.6700003,0.9 9.6700003,7.2 0,5.85 -0.45,12.6 -0.45,12.6 0,0 2,-0.68 10.57,-5.63 10.12,-6.07 12.82,-7.19 20.24,-5.84 7.87,1.57 59.369,11.24 59.369,11.24 0,0 10.57,1.8 10.35,-6.52 0,-3.6 0.22,11 0,-25.86 0,0 -19.339,3.59 -37.999,7.87 -16.41,3.6 -30.36,6.29 -32.38,7%22/%3E%3Cpath d=%22m 40.008099,44.731322 a 5.48,5.48 0 0 0 -5.400391,5.398438 v 24.509765 a 5.48,5.48 0 0 0 5.400391,5.400391 l 47.451171,-6.75 a 5.47,5.47 0 0 0 5.398438,-5.400391 v -11 A 5.47,5.47 0 0 0 87.45927,51.500854 v -0.01953 z m 9.160156,10.984375 a 7,7 0 0 1 7.291015,6.994141 7,7 0 0 1 -7,7 7,7 0 0 1 -0.291015,-13.994141 z m 29.935547,1.589844 a 5.4,5.4 0 0 1 5.625,5.394531 5.48,5.48 0 0 1 -5.400391,5.400391 5.4,5.4 0 0 1 -0.224609,-10.794922 z%22 /%3E%3Cpath d=%22m 128.61841,105.45047 c 0,-0.22 -1.57,-34.18 -2,-43.63 -0.23,-6.3 -2.7,-9 -2.7,-9 0,0 -9.9,-8.1 -13.95,-11.25 -3.14,-2.47 -8.09,-3.82 -9.22,-4 h -0.42 c -1.569,-0.22 -12.139,-2 -25.179,-4 l 9,-5.17 -8.55,-6.74 a 10.59,10.59 0 0 0 5.85,-9.68 10.79,10.79 0 0 0 -10.85,-10.88 10.66,10.66 0 0 0 -10.8,10.79 10.48,10.48 0 0 0 7.2,10.13 l 7,5.62 -7.67,4.46 c -18.66,-2.93 -38.9,-6.3 -42.73,-7 -6.52,-1.12 -5.84,5.18 -5.84,5.18 v 66.82 c 0,4.720007 -0.68,6.750007 5.62,11.240007 7.2,5.4 22.94,17.55 22.94,17.55 0.67,0.45 1.57,1.12 2.25,0.9 15.52,-3.6 60.939,-13.27 73.089,-15.75 7.64,-1.57 7,-4 7,-5.62 M 70.818411,6.720463 a 5.18,5.18 0 0 1 0,10.35 5.23,5.23 0 0 1 -5.17,-5.18 5.38,5.38 0 0 1 5.17,-5.17 m 29.909,83 c -11.469,1.57 -14.619,0.22 -14.619,5.85 v 0.89 c 0.23,9.900007 -0.44,7.880007 -6.29,3.600007 a 0.22,0.22 0 0 1 -0.23,-0.220003 c -6.07,-4.000004 -8.32,-5.400004 -12.82,-4.270004 -4.5,1.13 -37.55,7.640007 -37.55,7.640007 0,0 -6.53,1.13 -6.53,-3.820007 0.23,-5 0,-63.2 0,-63.42 0,-1.58 0.23,-5.85 6.08,-4.95 7.42,1.08 70.16,11.91 70.16,11.91 0,0 6.299,0.67 6.079,7 -0.45,6.3 0,28.56 0,32.61 0.22,1.13 0,6.52 -4.28,7.2%22/%3E%3C/svg%3E');
  }
}

.widget-push {
  font-family: Consolas, Verdana, sans-serif;
  font-size: 7pt;
  font-weight: bold;
  position: absolute;
  z-index: 101;
  left: 0;
  top: 0;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  color: #fff;
  background-color: #00cc00;
  background-image: linear-gradient(0, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
  padding: 0 0.7em;
  border-radius: 1em;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.8);
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.32);
  animation: bounceAnimation 0.35s ease-out infinite alternate;
  animation-play-state: running;
}

@keyframes bounceAnimation {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-4px);
  }
}

.widget {
  header.lighter,
  .widget-msg.me.lighter > div > span,
  .widget-msg.me.lighter > div time,
  .widget-msg.me.lighter .widget-status,
  .widget-msg.me.lighter .widget-msg-status {
    color: #000 !important;
  }

  .widget-min.lighter {
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M 10,510 500,1000 990,510 892,412 500,804 108,412 Z%22 fill=%22%23000%22/%3E%3C/svg%3E') !important;
  }

  .widget-close.lighter {
    background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 1000 1000%22%3E%3Cpath d=%22M990,108.7L598.7,500L990,891.3L891.3,990L500,598.7L108.7,990L10,891.3L401.3,500L10,108.7L108.7,10L500,401.3L891.3,10L990,108.7z%22 fill=%22%23000%22/%3E%3C/svg%3E') !important;
  }

  // .lighter .widget-logo {
  //   background-image: url('../assets/logo.svg#dark') !important;
  // }
}

/* Rebranding */

.form-group .material-icons,
.form-group .material-icons-outlined {
  color: #9ca7b0;
}

.config-form div::before {
  color: #9ca7b0;
}

.username-input,
/* .msg-text, */
.lang-wrapper {
  display: flex;
  align-items: center;
}

.username-input::before {
  content: '\e7fd';
  font-family: 'Material Symbols Outlined';
  font-size: 28px;
  margin-right: 0.75rem;
}

/* .msg-text {
  flex-wrap: wrap;
} */

/* .msg-text::before {
  content: '\e163';
  font-family: 'Material Symbols Outlined';
  font-size: 28px;
  margin-right: 0.75rem;
} */

.msg-text textarea,
.message-wrapper textarea {
  min-height: 100px;
}

/* Profile Picture */
.profile-picture {
  margin-left: auto;

  img {
    width: 55px;
  }
}

/* Color picker */
.control-group.opt-3 .control_indicator {
  background: var(--clr-yup-purple);
  border: 2px solid var(--clr-yup-purple);
  border-radius: 100%;
  height: 30px;
  width: 30px;
}

.control-group.opt-3 .control_indicator.orange,
.control-group.opt-3 .control:hover input ~ .control_indicator.orange,
.control-group.opt-3 .control input:focus ~ .control_indicator.orange {
  background: #e67e2d;
  border-color: #e67e2d;
}

.control-group.opt-3 .control_indicator.yellow,
.control-group.opt-3 .control:hover input ~ .control_indicator.yellow,
.control-group.opt-3 .control input:focus ~ .control_indicator.yellow {
  background: #e0e62d;
  border-color: #e0e62d;
}

.control-group.opt-3 .control_indicator.blue,
.control-group.opt-3 .control:hover input ~ .control_indicator.blue,
.control-group.opt-3 .control input:focus ~ .control_indicator.blue {
  background: #2d4ce6;
  border-color: #2d4ce6;
}

.control-group.opt-3 .control_indicator.gray,
.control-group.opt-3 .control:hover input ~ .control_indicator.gray,
.control-group.opt-3 .control input:focus ~ .control_indicator.gray {
  background: var(--gray-font-color);
  border-color: var(--gray-font-color);
}

.control-group.opt-3 .control_indicator.color-selector,
.control-group.opt-3 .control:hover input ~ .control_indicator.color-selector,
.control-group.opt-3 .control input:focus ~ .control_indicator.color-selector {
  background: #fff;
  border-color: var(--gray-font-color);
}

.control-group.opt-3 .control_indicator.color-selector[style] {
  border: none;
}

.control-group.opt-3 .control-checkbox .control_indicator.color-selector::after {
  content: '\e5d3';
  display: inline-block;
  color: #fff;
}

.control-group.opt-3 .control-checkbox .control_indicator.color-selector.lighter::after {
  color: #000;
}

.control-group.opt-3 .control:hover input ~ .control_indicator,
.control-group.opt-3 .control input:focus ~ .control_indicator {
  background: var(--clr-yup-purple);
}

.control-group.opt-3 .control-checkbox .control_indicator::after {
  left: 5px;
  top: 5px;
}

.control-group.opt-3 .control-checkbox .control_indicator::after {
  border-width: 0;
  content: '\e5ca';
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 18px;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  transform: none;
  color: #fff;
}

.control_indicator.color-selector.default {
  border: 1px solid !important;
}

.colors ul {
  display: flex;
  gap: 5px;
}

.colors ul li {
  width: fit-content;
}

/* Color menu */
.color-menu {
  display: none;
  position: absolute;
  top: 100%;
  right: -100%;
  width: 410px;
  z-index: 1;

  .card {
    background-color: #f7f7f7;
    box-shadow: 0 3px 6px #0000001a;
    width: 100%;

    .card-body {
      padding: 0.5rem;

      h5 {
        cursor: pointer;
        color: var(--clr-yup-purple);
        display: flex;
        align-items: center;
        gap: 5px;
        transition: 0.5s;
      }
    }

    .form-control {
      height: 28px;
      width: 85%;
      margin-top: 0.5rem;
    }
  }

  .colors-sample-wrapper {
    gap: 5px;
    padding-left: 10px;
  }

  .color-btn-wrapper {
    padding: 0.1rem;
  }

  .btn-sample-color {
    width: 18px;
    height: 18px;
    border: none;
    border-radius: 9px;
  }

  .btn-sample-color:focus {
    outline: 0;
  }
}

.darkmode .color-menu .card,
.darkmode .color_picker-wrapper,
.darkmode .color_picker-push-wrapper {
  background-color: var(--background-2);
}

.color-menu .card .card-body h5:hover {
  transform: scale(1.03);
}

.color-menu .control-group.opt-3 .control_indicator {
  height: 18px;
  width: 18px;
}

.color_picker-wrapper,
.color_picker-push-wrapper {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #f7f7f7;
  box-shadow: 0 3px 6px #0000001a;
  padding: 0.5rem;

  .vc-sketch {
    margin: auto;
  }
}

.color-menu .control-group.opt-3 .control-checkbox .control_indicator::after {
  font-size: 14px;
}

.color-menu .control-group.opt-3 .control-checkbox .control_indicator::after {
  left: 0;
  top: 0;
}

/* Lang menu */
::v-deep .lang-menu .dropdown-menu {
  transform: unset !important;
  width: 100%;

  a {
    text-transform: uppercase;
  }
}

::v-deep .lang-menu {
  width: 100%;

  .form-control {
    padding: 0.7rem;
    height: fit-content;
  }
}

::v-deep .lang-menu button {
  display: flex;
  align-items: center;
  text-align: start;
}

::v-deep .lang-menu button::after {
  margin-left: auto;
  content: '\e5cf';
  font-family: 'Material Symbols Outlined';
  font-size: 16px;
  border: none;
  transform: scale(1.7);
}

/* .lang-wrapper::before {
  content: '\e894';
  font-family: 'Material Symbols Outlined';
  font-size: 28px;
  margin-right: 0.75rem;
} */

/* Copy and paste script */
.script-content {
  box-shadow: 0 0 3px 0 #d6dadd;
}

.widget-sample {
  height: 480px;
  width: 320px;
  z-index: 1;
  box-shadow: unset !important;
  margin: auto;
  left: unset !important;
  right: unset !important;
  transform: unset !important;
}

.widget-config-aligns {
  background-color: var(--background-2);
}

.darkmode .widget-config-aligns,
.darkmode .widget-config-aligns p {
  border: thin solid var(--background-3);
}

.widget-config-aligns button:hover,
.widget-config-aligns button.active {
  background: var(--clr-yup-purple);
  border: thin solid var(--clr-yup-purple);
}

.darkmode .widget-config-aligns button {
  border: thin solid var(--clr-yup-purple);
}

.icon-wrapper {
  position: absolute;
  top: 55px;
  left: 0;
  width: fit-content;

  .chat-icon {
    width: 62px;
    height: 62px;
  }

  & > svg {
    width: 62px;
    height: 62px;
  }

  button {
    position: absolute;
    top: -10px;
    right: -20px;
    padding: 6px;
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid #c2c2c2;
    transform: scale(0.7);
    color: #c2c2c2;
  }
}

@media (min-width: 1440px) {
  .icon-wrapper {
    left: 16px;
  }
}

.alignement-column .card {
  .card-header {
    p {
      color: var(--gray-font-color-2);
      margin-bottom: 0;
      font-size: 1.2rem;
    }
  }
  button {
    display: flex;
    align-items: center;
  }
}

@media (min-width: 1600px) {
  .alignement-column .card {
    width: 80%;

    .card-body,
    .card-header {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
}
@media (min-width: 1200px) {
  .c-container {
    max-width: 1100px;
  }
}
.language-row,
.color-row,
.username-row,
.message-row,
.position-row {
  margin-bottom: 2.5rem;
  div:first-of-type {
    p:first-of-type {
      font-weight: 400;
      font-size: 1rem;
      color: var(--foreground);
    }
    p:last-of-type {
      color: var(--gray-font-color-5);
    }
  }
  .form-control {
    padding: 0.7rem;
    height: fit-content;
  }
}
.col-widget {
  background-color: #f7f7f7;
  padding-top: 4.12rem;
  padding-left: 4rem;
  padding-right: 4rem;
  p {
    font-size: 1rem;
  }
  .live-simulate-client,
  .embed-code {
    padding-left: 0.6rem;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .embed-code {
    p:last-of-type {
      font-size: 0.825rem;
      color: var(--gray-font-color-5);
    }
  }

  .sim-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0 100%;
    max-width: 100%;
    padding-top: 1.5rem;
  }
  .center-both {
    margin: 0 auto;
  }
  .live-simulate-client {
    display: flex;
    align-items: center;
    font-weight: 400;
  }
  .code-wrapper {
    padding: 0.625rem;
    .script-content {
      background-color: #f0f0f0;
      padding: 1.25rem;
      color: #595959;
      font-weight: 400;
    }
    .copy-code {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
  }
  .preview-wrapper {
    position: relative;
    width: 100%;
    .widget-preview,
    .widget-icon-preview {
      position: absolute;
    }
    .widget-preview {
      bottom: 80px;
    }
    .widget-icon-preview {
      bottom: 18px;
    }
    &.widget-right {
      .widget-preview,
      .widget-icon-preview {
        right: 30px;
      }
    }
    &.widget-center {
      .widget-preview,
      .widget-icon-preview {
        right: calc(50% - 4rem);
      }
    }
    &.widget-left {
      .widget-preview,
      .widget-icon-preview {
        left: 30px;
      }
    }
  }
}
.chat-icon {
  margin-bottom: 4rem;
  > .row > div:first-of-type {
    p:first-child {
      font-weight: 400;
      font-size: 1rem;
      color: var(--foreground);
    }
  }
  .icon-images {
    display: flex;
    gap: 4rem;
    img {
      width: inherit;
      height: fit-content;
      max-width: 100px;
    }
    .widget-icon-wrapper {
      border: none;
      background: transparent;
      position: relative;
      box-shadow: 0 0 0 0 transparent;
      border-radius: 0;
      transition: 0.2s;
      outline: none;

      &.active {
        box-shadow: 0 0 1px 2px var(--clr-yup-purple);
        border-radius: 5px;

        &::before {
          font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;
          content: '\e86c';
          font-family: 'Material Symbols Outlined';
          font-size: 28px;
          position: absolute;
          top: -15px;
          right: -15px;
          color: var(--clr-yup-purple);
          z-index: 5;
          background-color: #fff;
          border-radius: 18px;
          line-height: 30px;
        }
      }
    }
  }
}
.color-column {
  ul {
    display: flex;
    gap: 10px;
  }
}
.position-wrapper {
  display: flex;
  gap: 2.62rem;
  img {
    box-shadow: 0 0 0 0 transparent;
    border-radius: 0;
    max-width: 225px;
    transition: 0.2s;
    @media (min-width: 1440px) {
      max-width: 245px;
    }
  }
  picture {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    span {
      color: var(--gray-font-color-5);
      font-size: 0.875rem;
      font-weight: 400;
      padding-left: 0.5rem;
    }
    &.active {
      &:before {
        font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 48;
        content: '\e86c';
        font-family: 'Material Symbols Outlined';
        font-size: 28px;
        position: absolute;
        top: -15px;
        right: -15px;
        color: var(--clr-yup-purple);
        z-index: 5;
        background-color: #fff;
        height: 36px;
      }
      img {
        box-shadow: 0 0 1px 2px var(--clr-yup-purple);
        border-radius: 5px;
      }
    }
  }
}
</style>
